import React, { useMemo } from 'react';
import { Tab, Tabs, TabsList, TypographyBody, TypographyHeading } from '@honeycomb/ui-core';
import { TripType, useGlobalContext } from '@honeycomb/data';
import { interjectResourceString } from '../../../../utils';
export function LandingPagePriceCalendarHeader({ selectedTrip, handleTabChange, duration, }) {
    const { resourceStrings: { HC_ESTAB_LANDING_CALENDAR_HEADING_HOLIDAY, HC_ESTAB_LANDING_CALENDAR_HEADING_HOTEL, SEARCH_TABS_HOTEL_LABEL, SEARCH_TABS_HOLIDAY_LABEL, HC_PRICING_CALENDAR_TITLE, }, } = useGlobalContext();
    const searchTabs = [
        { key: TripType.Holiday, value: SEARCH_TABS_HOLIDAY_LABEL },
        { key: TripType.Hotel, value: SEARCH_TABS_HOTEL_LABEL },
    ];
    const subheading = useMemo(() => interjectResourceString(selectedTrip === TripType.Holiday
        ? HC_ESTAB_LANDING_CALENDAR_HEADING_HOLIDAY
        : HC_ESTAB_LANDING_CALENDAR_HEADING_HOTEL, {
        duration,
    }), [selectedTrip, HC_ESTAB_LANDING_CALENDAR_HEADING_HOLIDAY, HC_ESTAB_LANDING_CALENDAR_HEADING_HOTEL, duration]);
    return (React.createElement("div", null,
        React.createElement(TypographyHeading, { size: "s", color: "text.body", mb: 2 }, HC_PRICING_CALENDAR_TITLE),
        React.createElement(TypographyBody, { color: "text.light", mb: 4 }, subheading),
        React.createElement(Tabs, { "aria-label": "Pricing Calendar tabs", onChange: (_e, value) => {
                handleTabChange(value);
            }, value: selectedTrip, positioning: "default" },
            React.createElement(TabsList, null, searchTabs.map((tab) => (React.createElement(Tab, { value: tab.key, key: tab.key, "data-id": "search-tab", "data-key": tab.key }, tab.value)))))));
}
